/**
 * AirStore Theme - Main JavaScript
 */

const AirStoreTheme = (function() {
  'use strict';

  const $ = (id) => document.getElementById(id);
  const $$ = (sel) => document.querySelectorAll(sel);

  let cart = { items: [], item_count: 0, total_price: 0 };
  let mainVariantId = null;

  function init() {
    const addBtn = $('addToCartBtn');
    if (addBtn) mainVariantId = addBtn.dataset.variantId || null;

    fetchCart().then(() => {
      initCartEvents();
      initComparisonSlider();
      initScrollReveal();
      initStickyCta();
      checkGdpr();
      updateViewerCount();
      updateAddToCartButton();
    });
    initServiceHandlers();

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeCart(); closeAllReviews(); closeLightbox(); closePrivacy();
      }
    });
  }

  function initCartEvents() {
    const container = $('cartItemsContainer');
    if (!container) return;
    container.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const action = btn.dataset.action;
      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty, 10);

      if (action === 'remove') removeFromCart(key);
      else if (action === 'update') updateCartQty(key, qty);
    });
  }

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Failed');
      cart = await res.json();
      updateCartUI();
      updateAddToCartButton();
    } catch (e) {
      console.error('Cart fetch error:', e);
    }
  }

  function updateAddToCartButton() {
    const btn = $('addToCartBtn');
    if (!btn || !mainVariantId) return;

    const inCart = cart.items.some(i => String(i.variant_id) === String(mainVariantId));
    const txt = btn.querySelector('.btn-text');
    if (!txt) return;

    if (inCart) {
      txt.textContent = '✅ Добавено';
      btn.style.background = '#16a34a';
      btn.onclick = () => openCart();
    } else {
      txt.textContent = '🛒 Добави в кошницата';
      btn.style.background = '';
      btn.onclick = () => addToCart(mainVariantId, 1);
    }
  }

  async function addToCart(variantId, qty) {
    const btn = $('addToCartBtn');
    if (btn) {
      btn.disabled = true;
      const txt = btn.querySelector('.btn-text');
      const load = btn.querySelector('.btn-loading');
      if (txt) txt.style.display = 'none';
      if (load) load.style.display = 'inline';
    }

    try {
      // Build items array with main product + selected addons
      const items = [{ id: variantId, quantity: qty }];

      // Get selected addons
      const addonCheckboxes = document.querySelectorAll('.addon-checkbox:checked');
      addonCheckboxes.forEach(function(cb) {
        const addonId = cb.dataset.variantId;
        if (addonId && addonId !== '') {
          items.push({ id: parseInt(addonId), quantity: 1 });
        }
      });

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description); }

      await fetchCart();
      openCart();
      showToast('Добавено в кошницата!', 'success');

      if (typeof gtag !== 'undefined') {
        gtag('event', 'add_to_cart', {
          currency: shop.currency,
          value: cart.total_price / 100,
          items: items.map(i => ({
            item_id: i.id,
            quantity: i.quantity
          }))
        });
      }
    } catch (e) {
      showToast(e.message || 'Грешка при добавяне', 'error');
      console.error(e);
    } finally {
      if (btn) {
        btn.disabled = false;
        const txt = btn.querySelector('.btn-text');
        const load = btn.querySelector('.btn-loading');
        if (txt) txt.style.display = '';
        if (load) load.style.display = 'none';
      }
    }
  }

  async function updateCartQty(key, qty) {
    if (qty < 0) qty = 0;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description); }
      cart = await res.json();
      updateCartUI();
      updateAddToCartButton();
    } catch (e) {
      showToast('Грешка при обновяване.', 'error');
    }
  }

  async function removeFromCart(key) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description); }
      cart = await res.json();
      updateCartUI();
      updateAddToCartButton();
      showToast('Продуктът е премахнат', 'success');
    } catch (e) {
      showToast('Грешка при премахване.', 'error');
    }
  }

  function updateCartUI() {
    const badge = $('cartBadge');
    const emptyCart = $('emptyCart');
    const cartContent = $('cartContent');
    const drawerFooter = $('drawerFooter');
    const container = $('cartItemsContainer');
    const totalPrice = $('cartTotalPrice');

    // Get service variant IDs from DOM
    const serviceIds = [];
    document.querySelectorAll('.service-checkbox').forEach(cb => {
      if (cb.dataset.variantId) serviceIds.push(String(cb.dataset.variantId));
    });

    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'grid' : 'none';
    }

    if (cart.item_count === 0) {
      if (emptyCart) emptyCart.style.display = 'block';
      if (cartContent) cartContent.style.display = 'none';
      if (drawerFooter) drawerFooter.style.display = 'none';
    } else {
      if (emptyCart) emptyCart.style.display = 'none';
      if (cartContent) cartContent.style.display = 'block';
      if (drawerFooter) drawerFooter.style.display = 'block';

      if (container) {
        const products = cart.items.filter(item => !serviceIds.includes(String(item.variant_id)));
        const services = cart.items.filter(item => serviceIds.includes(String(item.variant_id)));

        let html = '';

        // Products
        html += products.map(item => `
          <div class="cart-item">
            <button class="remove-btn" data-action="remove" data-key="${item.key}" title="Премахни">🗑️</button>
            <div class="cart-item-img">
              <img src="${item.image || ''}" alt="${item.title}" width="52" height="52" loading="lazy"
                   onerror="this.src='https://cdn.shopify.com/s/images/admin/no-image-compact.gif'">
            </div>
            <div class="cart-item-info">
              <div class="cart-item-title">${item.product_title}</div>
              <div class="cart-item-meta">${item.variant_title || ''}</div>
              <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
              <div class="qty-control">
                <button class="qty-btn" data-action="update" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
                <span class="qty-value">${item.quantity}</span>
                <button class="qty-btn" data-action="update" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
              </div>
            </div>
          </div>
        `).join('');

        // Services (rendered compact)
        html += services.map(item => `
          <div class="cart-service-line">
            <span class="service-tag">Услуга</span>
            <span class="service-line-name">${item.product_title}</span>
            <span class="service-line-price">${formatMoney(item.final_line_price)}</span>
            <button class="service-remove" data-action="remove" data-key="${item.key}" title="Премахни">✕</button>
          </div>
        `).join('');

        container.innerHTML = html;
      }
    }

    // Sync checkboxes
    document.querySelectorAll('.service-checkbox').forEach(cb => {
      const vid = cb.dataset.variantId;
      if (!vid) return;
      const inCart = cart.items.some(i => String(i.variant_id) === String(vid));
      cb.checked = inCart;
    });

    if (totalPrice) {
      totalPrice.innerHTML = formatMoney(cart.total_price);
    }
  }

  function openCart() {
    const overlay = $('overlay');
    const drawer = $('drawer');
    if (overlay) overlay.classList.add('show');
    if (drawer) drawer.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    const overlay = $('overlay');
    const drawer = $('drawer');
    if (overlay) overlay.classList.remove('show');
    if (drawer) drawer.classList.remove('show');
    document.body.style.overflow = '';
  }

  // ===== LIGHTBOX =====
  function openLightbox() {
    const mainImg = $('mainImg');
    const lightboxImg = $('lightboxImage');
    if (mainImg && lightboxImg) {
      lightboxImg.src = mainImg.src;
      $('lightboxModal').classList.add('show');
    }
  }

  function closeLightbox() {
    const m = $('lightboxModal');
    if (m) m.classList.remove('show');
  }

  function changeImage(btn, src) {
    const mainImg = $('mainImg');
    if (mainImg) mainImg.src = src;
    $$('.th').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  // ===== COMPARISON SLIDER =====
  function initComparisonSlider() {
    const slider = $('comparisonSlider');
    const beforeImage = $('beforeImage');
    const handle = $('sliderHandle');
    if (!slider || !beforeImage || !handle) return;

    let isDragging = false;
    function updateSlider(clientX) {
      const rect = slider.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(5, Math.min(95, pct));
      beforeImage.style.width = pct + '%';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('mousedown', (e) => { isDragging = true; slider.classList.add('dragging'); e.preventDefault(); });
    slider.addEventListener('mousemove', (e) => { if (!isDragging) return; e.preventDefault(); updateSlider(e.clientX); });
    document.addEventListener('mouseup', () => { isDragging = false; slider.classList.remove('dragging'); });

    handle.addEventListener('touchstart', (e) => { isDragging = true; slider.classList.add('dragging'); e.preventDefault(); }, {passive: false});
    slider.addEventListener('touchmove', (e) => { if (!isDragging) return; e.preventDefault(); updateSlider(e.touches[0].clientX); }, {passive: false});
    slider.addEventListener('touchend', () => { isDragging = false; slider.classList.remove('dragging'); });
    slider.addEventListener('click', (e) => { if (e.target === handle || e.target.closest('.comparison-handle')) return; updateSlider(e.clientX); });
  }

  // ===== REVIEWS MODAL =====
  function openAllReviews() {
    const m = $('allReviewsModal');
    if (m) m.classList.add('show');
  }

  function closeAllReviews() {
    const m = $('allReviewsModal');
    if (m) m.classList.remove('show');
  }

  // ===== SCROLL REVEAL =====
  function initScrollReveal() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    $$('.reveal').forEach(el => observer.observe(el));
  }

  // ===== STICKY CTA =====
  function initStickyCta() {
    const cta = $('stickyCta');
    const hero = document.querySelector('.hero-section');
    if (!cta || !hero) return;

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          cta.classList.toggle('show', hero.getBoundingClientRect().bottom < 0 && cart.item_count === 0);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ===== GDPR =====
  function checkGdpr() {
    const consent = localStorage.getItem('gdpr_consent');
    const banner = $('gdprBanner');
    if (!consent && banner) banner.classList.add('show');
  }

  function gdprAccept() {
    localStorage.setItem('gdpr_consent', 'accepted');
    const banner = $('gdprBanner');
    if (banner) banner.classList.remove('show');
  }

  function gdprDecline() {
    localStorage.setItem('gdpr_consent', 'declined');
    const banner = $('gdprBanner');
    if (banner) banner.classList.remove('show');
  }

  function openPrivacy() {
    const m = $('privacyModal');
    if (m) m.classList.add('show');
  }

  function closePrivacy() {
    const m = $('privacyModal');
    if (m) m.classList.remove('show');
  }

  // ===== VIEWER COUNT =====
  function updateViewerCount() {
    const el = $('viewerCount');
    if (!el) return;
    setInterval(() => { el.textContent = Math.floor(Math.random() * 15) + 8; }, 8000);
  }

  // ===== TOAST =====
  function showToast(msg, type) {
    const toast = $('toast');
    const message = $('toastMessage');
    if (!toast || !message) return;
    message.textContent = msg;
    toast.className = 'toast show toast-' + type;
    setTimeout(() => toast.classList.remove('show'), 2500);
  }

  // ===== UTILITIES =====
  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const formattedValue = value.replace('.', ',');
    let result = window.theme.moneyFormat || '€{{amount}}';
    result = result.replace(/\{\{\s*amount\s*\}\}/g, value);
    result = result.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    result = result.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formattedValue);
    result = result.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, value.replace('.', "'"));
    return result;
  }

  return {
    init, addToCart, updateCartQty, removeFromCart,
    openCart, closeCart,
    openLightbox, closeLightbox, changeImage,
    openAllReviews, closeAllReviews,
    gdprAccept, gdprDecline, openPrivacy, closePrivacy,
    showToast
  };


  // Service add/remove handlers
  function initServiceHandlers() {
    var servicesBox = document.getElementById('cartServices');
    if (!servicesBox) return;
    servicesBox.addEventListener('change', function(e) {
      var cb = e.target.closest('.service-checkbox');
      if (!cb) return;
      var variantId = cb.dataset.variantId;
      if (!variantId || variantId === '') {
        showToast('Тази услуга не е конфигурирана. Моля, задайте Variant ID в Theme Editor.', 'error');
        cb.checked = false;
        return;
      }
      if (cb.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
        }).then(function(r) {
          if (!r.ok) return r.json().then(function(err){ throw new Error(err.description || 'Failed'); });
          return fetchCart();
        }).then(function() {
          showToast('Услугата е добавена!', 'success');
        }).catch(function(e) {
          cb.checked = false;
          showToast(e.message || 'Грешка при добавяне', 'error');
          console.error('Service add error:', e);
        });
      } else {
        var item = cart.items.find(function(i) { return String(i.variant_id) === String(variantId); });
        if (item) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          }).then(function(r) {
            if (!r.ok) throw new Error('Failed');
            return fetchCart();
          }).then(function() {
            showToast('Услугата е премахната', 'success');
          }).catch(function(e) {
            console.error('Service remove error:', e);
          });
        }
      }
    });
  }

})();

document.addEventListener('DOMContentLoaded', AirStoreTheme.init);
